package device

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable
import org.ssoft.common.tools.nowDateTime
import kotlin.time.Clock
import kotlin.time.Duration
import kotlin.time.Duration.Companion.seconds


@Serializable
data class DeviceReportSystem(
    val index: Long,
    val host: String = "?",
    val cpu: String = "?",
    val dt: Dt,
    val uptime: Uptime,
    val ram: Ram,
    @Deprecated("by 25.08.2025")
    val disk: Disk = Disk.EMPTY,
    var storage: Storage = Storage(),
    val temperature: Temperature,
    val display: Display,
    val usb: List<UsbDevice>,
    val network: List<NetworkAdapter>,
    val appVersions: AppVersions = AppVersions()
) {
    companion object;

    @Serializable
    data class Ram(
        val free: Long,
        val size: Long,
        val used: Long = size - free,
    ) {
        companion object {
            val EMPTY get() = Ram(1024, 1024, 0)
        }
    }

    @Serializable
    data class Disk(
        val freeSystem: String,
        val sizeSystem: String,
        val freeStorage: String,
        val sizeStorage: String,
    ) {
        companion object {
            val EMPTY
                get() = Disk(
                    freeSystem = "1G",
                    sizeSystem = "1G",
                    freeStorage = "1G",
                    sizeStorage = "1G",
                )
        }
    }

    @Serializable
    data class AppVersions(
        val connector: Long = -1,
        val runtime: Long = -1,
        val updater: Long = -1,
    ) {
        companion object {
            val EMPTY
                get() = AppVersions()
        }
    }

    @Serializable
    data class Storage(
        val freeSystem: Long = 1000,
        val sizeSystem: Long = 1000,
        val freeStorage: Long = 1000,
        val sizeStorage: Long = 1000,
    ) {
        companion object {
            val EMPTY
                get() = Storage()
        }
    }

    @Serializable
    data class Dt(
        val now: LocalDateTime,
        val utc: LocalDateTime,
    ) {
        companion object {
            val EMPTY
                get() = Dt(
                    Clock.nowDateTime(),
                    Clock.nowDateTime()
                )
        }
    }

    @Serializable
    data class Uptime(
        val system: Duration,
        val app: Duration,
    ) {
        companion object {
            val EMPTY
                get() = Uptime(
                    0.seconds,
                    0.seconds
                )
        }
    }

    @Serializable
    data class UsbDevice(
        val id: String,
        val name: String,
    ) {
        companion object {
            val EMPTY get() = listOf<UsbDevice>()
        }
    }

    @Serializable
    data class NetworkAdapter(
        val name: String,
        val mac: String,
        val ip: String,
    ) {
        companion object {
            val EMPTY get() = listOf<NetworkAdapter>()
        }
    }

    @Serializable
    data class Display(
        val window: String,
        val app: String,
        var on: Boolean
    ) {
        companion object {
            val EMPTY
                get() = Display(
                    "800x600",
                    "800x600",
                    true
                )
        }
    }

    @Serializable
    data class Temperature(
        val a: Float,
        val b: Float,
        val c: Float,
        val d: Float,
        val e: Float,
    ) {
        companion object {
            val EMPTY
                get() = Temperature(
                    0F,
                    0F,
                    0F,
                    0F,
                    0F
                )
        }
    }
}
